import { ContentFilters, ContentTopBar } from "components";
import {
  MainFilters,
  MainFiltersParams,
} from "components/main-filters/main-filters";
import { RecurringBookingFilterFormValues } from "features/bookings/components/recurring-bookings-filter-form";
import { RenewalBookingsFilterForm } from "features/bookings/components/renewal-booking-filter-form/renewal-bookings-filter-form";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

type BookingTopBar = {
  setQueryParams: Dispatch<SetStateAction<MainFiltersParams | undefined>>;
  setQueryFilters: Dispatch<SetStateAction<RecurringBookingFilterFormValues>>;
  initialFilterValues: RecurringBookingFilterFormValues;
  resetTableCurrentPage: () => void;
};

export const RenewalBookingsTopBar = ({
  setQueryParams,
  setQueryFilters,
  initialFilterValues,
  resetTableCurrentPage,
}: BookingTopBar) => {
  const { t } = useTranslation();
  const formId = "recurring-booking-filters-form";

  const handleParams = ({
    company_type,
    company_id,
    facility_id,
  }: MainFiltersParams) => {
    resetTableCurrentPage();
    setQueryParams({
      company_type,
      company_id,
      facility_id,
    });
  };

  const handleFilter = (formData: RecurringBookingFilterFormValues) => {
    resetTableCurrentPage();
    setQueryFilters(formData);
  };

  return (
    <>
      <ContentTopBar
        title={t("RenewalBooking.heading")}
        renderHeadingContent={<MainFilters onChange={handleParams} />}
        ctFilter={
          <ContentFilters formId={formId}>
            <RenewalBookingsFilterForm
              formId={formId}
              handleFilter={handleFilter as any}
              initialValues={initialFilterValues}
            />
          </ContentFilters>
        }
      />
    </>
  );
};
